@import "../../packages/shared/scss";
$link-focus-padding: 2px;

:host {
  display: block;

  /* featureToggles.isFuelTypesEnabled() */
  phn-nd-signature-heading {
    display: block;
    inline-size: 100%;
    text-align: center;
    margin-block-start: p-px-to-rem(-52px);
    block-size: p-px-to-rem(38px);

    & .model-signature {
      display: block;
      margin-block: auto;
      margin-inline: auto;
    }
  }

  &:has(phn-model-tile) {
    .skeleton-link {
      margin-block: $pds-spacing-fluid-x-small !important;
      margin-inline: 0 !important;
      block-size: p-px-to-rem(56px) !important;
    }

    .skeleton-image {
      inline-size: 100% !important;
      margin-block: unset !important;
      margin-inline: unset !important;
      block-size: p-px-to-rem(215px) !important;
    }

    .series-body-type {
      @include pds-media-query-min("s") {
        aspect-ratio: 1.59;
      }

      @include model-max-width("l3");
      inline-size: 100%;

      a {
        text-decoration: none;
      }
    }

    .link {
      padding-block-start: $pds-spacing-fluid-x-small !important;
    }

    .model-signature {
      block-size: p-px-to-rem(38px);
      display: block;
      margin-block: auto;
      margin-inline: auto;
    }

    .links {
      display: block;
      box-sizing: border-box;
      @include model-max-width("l3");

      margin-block: auto;
      margin-inline: auto;
    }

    .further {
      margin-block-start: $pds-spacing-static-medium !important;
      padding-block: 0;
      padding-inline: 0;
    }

    .links:first-of-type {
      margin-block: p-px-to-rem(26px) $pds-spacing-static-medium;
      margin-inline: auto;
    }

    ul:has(phn-model-tile) {
      display: grid;
      place-items: center;
      gap: $pds-spacing-static-medium;

      & li {
        list-style: none;
      }
    }
  }

  ul {
    margin-block: 0;
    margin-inline: 0;
    padding-block: 0;
    padding-inline: 0;

    & li {
      list-style: none;
    }
  }

  phn-p-headline {
    font-size: p-px-to-rem(28px);
  }

  .model-link-content {
    @include hoverZoom();
    padding-block-end: 5px;
  }

  .skeleton-bodytype {
    block-size: p-px-to-rem(135px);
    inline-size: p-px-to-rem(260px);
    margin-block: 0;
    margin-inline: 0;
    margin-inline-start: p-px-to-rem(24px);
    background: $pds-theme-light-contrast-low;
    border-radius: 4px;

    @include pds-media-query-min("s") {
      block-size: p-px-to-rem(120px);
      inline-size: p-px-to-rem(260px);
    }
  }

  &.skeleton {
    pointer-events: none;
    user-select: none;
    opacity: 60%;

    & .skeleton-headline {
      inline-size: auto;
      block-size: p-px-to-rem(38px);
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;
    }

    & .skeleton-link {
      inline-size: auto;
      block-size: p-px-to-rem(48px);
      margin-block: p-px-to-rem(16px);
      margin-inline: 0;
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;
    }

    & .skeleton-image {
      inline-size: auto;

      @include model-max-width("l3");

      block-size: p-px-to-rem(135px);
      margin-block: p-px-to-rem(24px);
      margin-inline: 0;
      background: $pds-theme-light-contrast-low;
      border-radius: 4px;

      @include pds-media-query-min("s") {
        block-size: p-px-to-rem(120px);
      }

      @include pds-media-query-min("m") {
        block-size: p-px-to-rem(137px);
      }

      @include pds-media-query-min("xxl") {
        block-size: p-px-to-rem(145px);
      }
    }
  }

  .links {
    .link {
      inline-size: 100%;
      padding-block-start: p-px-to-rem(16px);
    }
  }

  .series-body-type {
    text-align: center;
    padding-block: p-px-to-rem(2px);
    padding-inline: p-px-to-rem(2px);
    margin-block-start: p-px-to-rem(2px);
  }

  .further {
    inline-size: 100%;
    padding-block-start: p-px-to-rem(64px);
  }

  .car-models {
    phn-p-text {
      font-size: p-px-to-rem(16px);

      @include pds-media-query-min("s") {
        font-size: p-px-to-rem(16px);
      }

      @include pds-media-query-min("xxl") {
        font-size: p-px-to-rem(18px);
      }
    }
  }
}
